(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function debounce(fn, wait) {
    var timeout;
    return function() {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        fn.apply(context, args);
      }, wait);
    };
  }

  function getItemWidth(list) {
    var item = list.querySelector('.featured-collection__item');
    if (!item) return list.clientWidth;
    var gap = parseFloat(getComputedStyle(list).gap) || 0;
    var width = item.getBoundingClientRect().width || 0;
    if (!width) return list.clientWidth;
    return width + gap;
  }

  function updateArrowVisibility(section) {
    var list = section.querySelector('[data-featured-collection-list]');
    var arrows = section.querySelector('[data-featured-collection-arrows]');
    if (!list || !arrows) return;

    var hasOverflow = list.scrollWidth > list.clientWidth + 1;

    if (hasOverflow) {
      arrows.classList.remove('is-hidden');
      var prev = section.querySelector('[data-featured-collection-prev]');
      var next = section.querySelector('[data-featured-collection-next]');
      if (prev) {
        if (list.scrollLeft <= 1) {
          prev.classList.add('is-hidden');
        } else {
          prev.classList.remove('is-hidden');
        }
      }
      if (next) {
        if (list.scrollLeft + list.clientWidth >= list.scrollWidth - 1) {
          next.classList.add('is-hidden');
        } else {
          next.classList.remove('is-hidden');
        }
      }
    } else {
      arrows.classList.add('is-hidden');
    }
  }

  function initFeaturedCollection(section) {
    if (section.dataset.featuredCollectionInitialized === 'true') return;
    section.dataset.featuredCollectionInitialized = 'true';

    var list = section.querySelector('[data-featured-collection-list]');
    if (!list) return;

    var prev = section.querySelector('[data-featured-collection-prev]');
    var next = section.querySelector('[data-featured-collection-next]');

    function scrollCarousel(direction) {
      if (list.dataset.isScrolling === 'true') return;
      list.dataset.isScrolling = 'true';
      list.scrollBy({ left: direction * getItemWidth(list), behavior: 'smooth' });
      setTimeout(function() {
        list.dataset.isScrolling = '';
      }, 500);
    }

    if (prev) {
      prev.addEventListener('click', function() {
        scrollCarousel(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function() {
        scrollCarousel(1);
      });
    }

    var update = function() {
      updateArrowVisibility(section);
    };

    list.addEventListener('scroll', update, { passive: true });

    var images = list.querySelectorAll('img');
    images.forEach(function(img) {
      if (img.complete) return;
      img.addEventListener('load', update, { once: true });
      img.addEventListener('error', update, { once: true });
    });

    update();
  }

  function initAll() {
    document.querySelectorAll('.featured-collection[data-section-id]').forEach(initFeaturedCollection);
  }

  function updateAll() {
    document.querySelectorAll('.featured-collection[data-section-id]').forEach(updateArrowVisibility);
  }

  function reinitSection(event) {
    if (!event.detail || !event.detail.sectionId) return;
    var section = document.querySelector('.featured-collection[data-section-id="' + event.detail.sectionId + '"]');
    if (!section) return;
    delete section.dataset.featuredCollectionInitialized;
    initFeaturedCollection(section);
    updateArrowVisibility(section);
  }

  function updateExisting(event) {
    if (!event.detail || !event.detail.sectionId) return;
    var section = document.querySelector('.featured-collection[data-section-id="' + event.detail.sectionId + '"]');
    if (section) updateArrowVisibility(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (!window.featuredCollectionListenersAdded) {
    window.featuredCollectionListenersAdded = true;
    var debouncedUpdateAll = debounce(updateAll, 150);
    window.addEventListener('resize', debouncedUpdateAll, { passive: true });
    window.addEventListener('load', updateAll);
    document.addEventListener('shopify:section:load', reinitSection);
    document.addEventListener('shopify:section:select', updateExisting);
    document.addEventListener('shopify:section:deselect', updateExisting);
    document.addEventListener('shopify:block:select', updateExisting);
    document.addEventListener('shopify:block:deselect', updateExisting);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["model-showcase-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function debounce(fn, wait) {
    var timeout;
    return function() {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        fn.apply(context, args);
      }, wait);
    };
  }

  function getFirstVisibleItem(list) {
    var items = list.querySelectorAll('.model-showcase-grid__item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].offsetParent !== null) return items[i];
    }
    return null;
  }

  function getVisibleItems(list) {
    var items = list.querySelectorAll('.model-showcase-grid__item');
    return Array.prototype.filter.call(items, function(item) {
      return item.offsetParent !== null;
    });
  }

  function getItemWidth(list) {
    var item = getFirstVisibleItem(list);
    if (!item) return 0;
    var gap = parseFloat(getComputedStyle(list).gap) || 0;
    var width = parseFloat(getComputedStyle(item).width) || item.getBoundingClientRect().width || 0;
    return width + gap;
  }

  function getVisibleItemCount(list) {
    var item = getFirstVisibleItem(list);
    if (!item) return 0;
    var gap = parseFloat(getComputedStyle(list).gap) || 0;
    var itemWidth = parseFloat(getComputedStyle(item).width) || item.getBoundingClientRect().width || 0;
    if (!itemWidth || !list.clientWidth) return 0;
    return Math.max(1, Math.round((list.clientWidth + gap) / (itemWidth + gap)));
  }

  function hasOverflow(list) {
    var visibleItems = getVisibleItems(list);
    if (!visibleItems.length) return false;
    var visibleCount = getVisibleItemCount(list);
    if (visibleCount > 0) {
      return visibleItems.length > visibleCount;
    }
    return list.scrollWidth > list.clientWidth + 1;
  }

  function setArrowVisibility(section, show) {
    var containers = section.querySelectorAll('[data-model-carousel-arrows]');
    containers.forEach(function(container) {
      if (show) {
        container.classList.remove('model-showcase-grid__arrows--hidden');
        container.removeAttribute('aria-hidden');
      } else {
        container.classList.add('model-showcase-grid__arrows--hidden');
        container.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function updateArrows(section, list) {
    setArrowVisibility(section, hasOverflow(list));
  }

  function scrollCarousel(list, direction) {
    if (list.dataset.isScrolling === 'true') return;
    list.dataset.isScrolling = 'true';
    list.scrollBy({ left: direction * getItemWidth(list), behavior: 'smooth' });
    setTimeout(function() {
      list.dataset.isScrolling = '';
    }, 450);
  }

  function initModelShowcaseGrid(wrapper) {
    if (wrapper.dataset.carouselInitialized === 'true') return;
    wrapper.dataset.carouselInitialized = 'true';

    var list = wrapper.querySelector('[data-model-carousel-list]');
    if (!list) return;

    var section = wrapper.closest('.model-showcase-grid');
    if (!section) return;

    var prevBtn = section.querySelector('[data-model-carousel-prev]');
    var nextBtn = section.querySelector('[data-model-carousel-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        scrollCarousel(list, -1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        scrollCarousel(list, 1);
      });
    }

    var update = function() {
      updateArrows(section, list);
    };

    update();

    var debouncedUpdate = debounce(update, 100);
    window.addEventListener('resize', debouncedUpdate);

    var mutationObserver = new MutationObserver(function() {
      update();
    });
    mutationObserver.observe(list, { childList: true });

    var images = list.querySelectorAll('img');
    images.forEach(function(img) {
      if (img.complete) return;
      img.addEventListener('load', debouncedUpdate, { once: true });
      img.addEventListener('error', debouncedUpdate, { once: true });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-model-carousel]').forEach(initModelShowcaseGrid);
  }

  function reinitSection(event) {
    if (!event.detail || !event.detail.sectionId) return;
    var section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"]');
    if (!section) return;
    var wrapper = section.querySelector('[data-model-carousel]');
    if (!wrapper) return;
    delete wrapper.dataset.carouselInitialized;
    initModelShowcaseGrid(wrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', reinitSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-frequently-bought-together"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initFbt(section) {
    var checkboxes = section.querySelectorAll('[data-fbt-checkbox]');
    var totalEl = section.querySelector('[data-fbt-total]');
    var addButton = section.querySelector('[data-fbt-add]');

    function updateTotal() {
      var total = 0;
      checkboxes.forEach(function(checkbox) {
        if (checkbox.checked) {
          var item = checkbox.closest('[data-fbt-item]');
          total += parseInt(item.dataset.price || 0, 10);
        }
      });
      if (totalEl) {
        totalEl.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: Shopify.currency.active || 'USD'
        }).format(total / 100);
      }
    }

    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', updateTotal);
    });

    if (addButton) {
      addButton.addEventListener('click', function() {
        var items = [];
        checkboxes.forEach(function(checkbox) {
          if (checkbox.checked) {
            items.push({ id: parseInt(checkbox.value, 10), quantity: 1 });
          }
        });
        if (items.length === 0) return;

        var originalText = addButton.textContent;
        addButton.disabled = true;
        addButton.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function(response) { return response.json(); })
          .then(function() { return fetch('/cart.js'); })
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function(el) {
              el.textContent = cart.item_count;
              el.hidden = cart.item_count === 0;
              el.classList.remove('is-pulse');
              void el.offsetWidth;
              el.classList.add('is-pulse');
              setTimeout(function() { el.classList.remove('is-pulse'); }, 500);
            });
            addButton.classList.remove('is-loading');
            addButton.classList.add('is-success');
            setTimeout(function() {
              addButton.classList.remove('is-success');
              addButton.disabled = false;
            }, 2000);
          })
          .catch(function() {
            addButton.classList.remove('is-loading');
            addButton.disabled = false;
            addButton.textContent = originalText;
          });
      });
    }

    updateTotal();
  }

  document.querySelectorAll('.product-fbt[data-section-id]').forEach(initFbt);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function getMainForm() {
    return document.querySelector('form[action*="/cart/add"]:not([data-sticky-form])');
  }

  function getMainVariantInput() {
    var form = getMainForm();
    return form ? form.querySelector('input[name="id"]') : null;
  }

  function getMainPrice() {
    return document.querySelector('.product-hero__price, .product-main__price, [data-price-wrapper]');
  }

  function updateStickyPrice(stickyPrice, mainPrice) {
    if (!stickyPrice || !mainPrice) return;
    stickyPrice.innerHTML = mainPrice.innerHTML;
  }

  function truncateStickyTitle(titleEl) {
    if (!titleEl) return;
    var fullTitle = titleEl.dataset.stickyTitle || titleEl.textContent || '';
    var limit = 15;
    if (window.innerWidth < 750 && fullTitle.length > limit) {
      titleEl.textContent = fullTitle.slice(0, limit) + '...';
    } else {
      titleEl.textContent = fullTitle;
    }
  }

  function getSelectedVariantTitle() {
    var form = getMainForm();
    if (!form) return '';
    var picker = form.querySelector('variant-picker');
    if (!picker) return '';
    var values = Array.from(picker.querySelectorAll('[data-selected-value]')).map(function(el) { return el.textContent.trim(); });
    return values.filter(Boolean).join(' / ');
  }

  function initStickyAddToCart(section) {
    if (!section || section.dataset.stickyInitialized === 'true') return;
    var mainForm = getMainForm();
    if (!mainForm) return;
    section.dataset.stickyInitialized = 'true';

    var stickyVariantInput = section.querySelector('[data-sticky-variant-id]');
    var stickyVariantTitle = section.querySelector('[data-sticky-variant-title]');
    var stickyTitle = section.querySelector('[data-sticky-title]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickyQuantity = section.querySelector('[data-sticky-quantity]');
    var stickyButton = section.querySelector('[data-sticky-add]');

    function getMainButton() {
      return mainForm.querySelector('[data-buy-buttons] button[name="add"], .product-main__buy-buttons button[name="add"], .product-hero__buy-buttons button[name="add"], .product-form__buttons button[name="add"], button[type="submit"][name="add"]');
    }

    function syncFromMain() {
      var mainVariant = getMainVariantInput();
      if (mainVariant && stickyVariantInput) {
        stickyVariantInput.value = mainVariant.value;
      }
      var mainQty = mainForm.querySelector('input[name="quantity"]');
      if (mainQty && stickyQuantity) {
        stickyQuantity.value = mainQty.value;
      }
      if (stickyVariantTitle) {
        stickyVariantTitle.textContent = getSelectedVariantTitle();
      }
      updateStickyPrice(stickyPrice, getMainPrice());

      var mainButton = getMainButton();
      if (stickyButton && mainButton) {
        stickyButton.disabled = mainButton.disabled;
        stickyButton.textContent = mainButton.textContent;
      }
    }

    var mainVariant = getMainVariantInput();
    if (mainVariant) {
      var variantObserver = new MutationObserver(syncFromMain);
      variantObserver.observe(mainVariant, { attributes: true, attributeFilter: ['value'] });
    }

    var picker = mainForm.querySelector('variant-picker');
    if (picker) {
      picker.addEventListener('change', syncFromMain);
    }

    var qty = mainForm.querySelector('input[name="quantity"]');
    if (qty) {
      qty.addEventListener('input', syncFromMain);
      qty.addEventListener('change', syncFromMain);
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        section.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -50px 0px' });

    var buyButtons = mainForm.querySelector('[data-buy-buttons]') || mainForm.querySelector('.product-main__buy-buttons, .product-hero__buy-buttons, .product-form__buttons');
    observer.observe(buyButtons || mainForm);

    syncFromMain();
    truncateStickyTitle(stickyTitle);

    if (stickyButton) {
      stickyButton.addEventListener('click', function() {
        syncFromMain();
      });
    }

    window.addEventListener('resize', debounce(function() {
      truncateStickyTitle(stickyTitle);
    }, 150));
  }

  function debounce(fn, wait) {
    var timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('[data-sticky-add-to-cart]').forEach(initStickyAddToCart);
    });
  } else {
    document.querySelectorAll('[data-sticky-add-to-cart]').forEach(initStickyAddToCart);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    function switchTab(section, targetId) {
      var tabs = Array.from(section.querySelectorAll('[data-tab]'));
      var panels = Array.from(section.querySelectorAll('[data-panel]'));
      if (!tabs.length || !panels.length) return;

      tabs.forEach(function(tab) {
        var isTarget = tab.dataset.target === targetId;
        tab.classList.toggle('is-active', isTarget);
        tab.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        tab.setAttribute('tabindex', isTarget ? '0' : '-1');
      });

      panels.forEach(function(panel) {
        var isTarget = panel.id === targetId;
        if (isTarget) {
          panel.removeAttribute('hidden');
          panel.classList.add('is-active');
        } else {
          panel.setAttribute('hidden', '');
          panel.classList.remove('is-active');
        }
      });

      updateActiveLine(section);
    }

    function updateActiveLine(section) {
      var line = section.querySelector('.product-tabs__active-line');
      if (!line) return;
      var tablist = line.parentElement;
      if (!tablist) return;
      var activeTab = section.querySelector('.product-tabs__tab.is-active');
      var title = activeTab ? activeTab.querySelector('.product-tabs__tab-title') : null;
      if (!activeTab || !title) {
        line.style.width = '0';
        return;
      }

      var tablistRect = tablist.getBoundingClientRect();
      var titleRect = title.getBoundingClientRect();
      line.style.width = titleRect.width + 'px';
      line.style.left = (titleRect.left - tablistRect.left + tablist.scrollLeft) + 'px';
    }

    function focusTab(section, direction) {
      var tabs = Array.from(section.querySelectorAll('[data-tab]'));
      var active = tabs.findIndex(function(t) { return t.getAttribute('aria-selected') === 'true'; });
      if (active === -1) return;
      var next = active + direction;
      if (next < 0) next = tabs.length - 1;
      if (next >= tabs.length) next = 0;
      switchTab(section, tabs[next].dataset.target);
      tabs[next].focus();
    }

    document.addEventListener('click', function(e) {
      var tab = e.target.closest('[data-tab]');
      if (!tab) return;
      var section = tab.closest('[data-product-tabs]');
      if (!section || section.dataset.layout !== 'tabs') return;
      switchTab(section, tab.dataset.target);
    });

    document.addEventListener('keydown', function(e) {
      var tab = e.target.closest('[data-tab]');
      if (!tab) return;
      var section = tab.closest('[data-product-tabs]');
      if (!section || section.dataset.layout !== 'tabs') return;

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        focusTab(section, 1);
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        focusTab(section, -1);
      } else if (e.key === 'Home') {
        e.preventDefault();
        var tabs = section.querySelectorAll('[data-tab]');
        if (tabs.length) {
          switchTab(section, tabs[0].dataset.target);
          tabs[0].focus();
        }
      } else if (e.key === 'End') {
        e.preventDefault();
        var tabs = section.querySelectorAll('[data-tab]');
        if (tabs.length) {
          var last = tabs[tabs.length - 1];
          switchTab(section, last.dataset.target);
          last.focus();
        }
      }
    });

    document.querySelectorAll('[data-product-tabs][data-layout="tabs"]').forEach(function(section) {
      updateActiveLine(section);
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        document.querySelectorAll('[data-product-tabs][data-layout="tabs"]').forEach(updateActiveLine);
      }, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
